import api from "./api"

export const upgradeSubscription = async (subscriptionId, newPlanId) => {
  const response = await api.put(`/subscriptions/${subscriptionId}/upgrade`, { newPlanId })
  return response.data
}

export const downgradeSubscription = async (subscriptionId, newPlanId) => {
  const response = await api.put(`/subscriptions/${subscriptionId}/downgrade`, { newPlanId })
  return response.data
}

export const cancelSubscription = async (subscriptionId, options) => {
  const response = await api.put(`/subscriptions/${subscriptionId}/cancel`, options)
  return response.data
}

export const renewSubscription = async (subscriptionId) => {
  const response = await api.put(`/subscriptions/${subscriptionId}/renew`)
  return response.data
}

export const handleFailedPayment = async (subscriptionId) => {
  const response = await api.put(`/subscriptions/${subscriptionId}/failed-payment`)
  return response.data
}

export const expireSubscription = async (subscriptionId, reason) => {
  const response = await api.put(`/subscriptions/${subscriptionId}/expire`, { reason })
  return response.data
}

export const reactivateSubscription = async (subscriptionId) => {
  const response = await api.put(`/subscriptions/${subscriptionId}/reactivate`)
  return response.data
}

export const switchBillingFrequency = async (subscriptionId, billingCycle) => {
  const response = await api.put(`/subscriptions/${subscriptionId}/billing-cycle`, { billingCycle })
  return response.data
}

export const getPaymentRecoverySettings = async () => {
  try {
    const response = await api.get("/payment-recovery/settings")
    return response
  } catch (error) {
    console.error("Error fetching payment recovery settings:", error)
    throw error
  }
}

export const updatePaymentRecoverySettings = async (settings) => {
  try {
    // Transform frontend model to backend model if needed
    const backendSettings = {
      enableDunning: settings.enableDunning,
      gracePeriodDays: settings.gracePeriodDays,
      maxPaymentAttempts: settings.maxPaymentRetries,
      paymentRetryInterval: settings.retryInterval / 24, // Convert hours to days
      enableAutoCancel: settings.cancelAfterFailedRetries,
      autoCancelAfterDays: settings.dunningPeriodDays,
      sendEmailNotifications: settings.sendEmailNotifications,
      dunningEmails: settings.dunningEmails || [
        { days: 1, enabled: settings.sendEmailNotifications },
        { days: 3, enabled: settings.sendEmailNotifications },
        { days: 5, enabled: settings.sendEmailNotifications },
      ],
    }

    const response = await api.put("/payment-recovery/settings", backendSettings)
    return response
  } catch (error) {
    console.error("Error updating payment recovery settings:", error)
    throw error
  }
}

